import React, { useEffect, useState } from "react";

import { HatGlasses } from "lucide-react";

import {
  masqueradeToken,
  masqueradingMinutesLeft,
  useMasqueradeBarOpen,
} from "@/util";
import { MASQUERADE_BAR_HEIGHT } from "@/NavBar/constants";
import { handleStopMasquerading } from "@/MasqueradePage/MasqueradeComponent";

export const MasqueradeBar: React.FC = () => {
  const whoAmI = masqueradeToken();
  const [minutesLeft, setMinutesLeft] = useState(0);
  const shouldShow = useMasqueradeBarOpen();

  useEffect(() => {
    const interval = setInterval(() => {
      setMinutesLeft(masqueradingMinutesLeft() ?? 0);
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  if (!shouldShow) {
    return null;
  }

  return (
    <div
      className="flex w-full justify-between bg-red-500 p-1"
      style={{ height: `${MASQUERADE_BAR_HEIGHT}px` }}
    >
      <div className="flex items-center gap-2 text-sm text-white">
        <HatGlasses size={20} />
        WARNING: Masquerading as {whoAmI}.{" "}
        {minutesLeft > 0 && `${minutesLeft} minutes left.`}
      </div>

      <button
        className="rounded-sm border border-white px-2 text-xs text-white uppercase hover:cursor-pointer hover:bg-white hover:text-black dark:hover:bg-gray-100"
        onClick={() => handleStopMasquerading()}
        title="Stop masquerading"
      >
        Stop
      </button>
    </div>
  );
};
